import _extends from "@babel/runtime/helpers/esm/extends";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useEffect } from "react";
import Search from "../search/Search";
import { retailLanding } from "./model/retail.model";
import * as UTIL from "../../util";
import { useQueryParams, StringParam, NumberParam } from 'use-query-params';
export var RetailLanding = function RetailLanding(props) {
  var _useQueryParams = useQueryParams({
    page: NumberParam
  }),
      _useQueryParams2 = _slicedToArray(_useQueryParams, 2),
      pageParam = _useQueryParams2[0].page,
      setQuery = _useQueryParams2[1];

  var _props$results = props.results,
      results = _props$results === void 0 ? [] : _props$results,
      _props$pageButtons = props.pageButtons,
      pageButtons = _props$pageButtons === void 0 ? "5" : _props$pageButtons,
      cards = props.cards,
      currentPage = props.currentPage;
  var params = {
    pageButtons: pageButtons,
    resultsCountLabel: "{0} of {1} results",
    resultsHeading: "Retail Info"
  };
  var filteredResults = results.filter(function (el) {
    return el.fields.hasZeroInv;
  });
  useEffect(function () {
    setQuery({
      page: currentPage
    });
  }, [currentPage]);
  return /*#__PURE__*/React.createElement("div", {
    className: "cb-retail__landing-wrapper"
  }, /*#__PURE__*/React.createElement(Search, _extends({}, props, params, {
    isRetail: true,
    noLocation: false,
    results: filteredResults
  })));
};